<app-main-layout></app-main-layout>
<app-ribbon [environment]="environment"></app-ribbon>
